import { useSelector } from "react-redux"
import { State } from "../../../../reducers"
import { getLogoEmpresa } from "../../../../actions/operaciones/operaciones.actions"
import { useEffect, useState } from "react"
import { Pagination } from "../../../../components/Pagination"
import { getFechaCA } from "../../../../utils/stringDate"
import { unirChipsJoin, unirChipsReturnFirst } from "../../../../utils/strings.utils"
import useUtilsDocs, { processDetalleImpuestosHTML } from "../../../../actions/utils-documentos.actions"
import { esNormativaV2 } from "../../../../utils/normativa.utils"
import { formatearDolares, repartirPorBase } from "../CamposV2/reparto-iva-nota"
import FilaDistritoDTE from "../CamposV2/FilaDistritoDTE"
import FilaFusionDTE from "../CamposV2/FilaFusionDTE"
import {TIPO_DTE, versionDteEmision} from '../../../../utils/version-documento.utils'
import {precioUnitarioNeto} from '../../../../utils/moneda.utils'
import {ivaSobreBase} from '../../../../utils/calculo-dte'
import {montosDeProducto, totalesDeDocumento} from '../../../../utils/calculo-otros-documentos'

import FilaDistritoEmisor from "../CamposV2/FilaDistritoEmisor";
export default function DTENotaCredito (){
    const {datosEmisor, tipoDocumento, tipoDocumentosEmision, actividadesEconomicas, municipios, departamentos, unidadesMedida, productos: productosCatalogo} = useSelector((state: State) => state.catalogos)
    const {formCliente, productos, response_QRcode, view, totalOriginal} = useSelector((state: State) => state.notaCredito )
    const {DetallesDTE: {receptor, identificacion}, TipoContribuyenteReceptor} = useSelector((state: State) => state.historial.activeFactura);
    const {datosUUID} = useSelector((state: State) => state.facturacion)
    const {datos} = useSelector((state: State) => state.userLogin)
    const datosReceptor = useSelector((state: State) => state.documentos.datosReceptor.form);

    const sucursal = formCliente?.datosSucursal?.find((suc: any) => suc?.idsucursal === formCliente.sucursal)?.nombre
    const documento = formCliente?.datosSucursal?.find((suc: any) => suc?.idsucursal === formCliente.sucursal)?.Documento?.find((doc: any) => doc.idsucursaldocumento === formCliente.serie)
    const serie = `${documento?.serie}-${documento?.numeroactual}`
    
    const {processOtrosImpuestosCalculo, procesOtrosImpuestosResumen} = useUtilsDocs()

    const emisorGranContribuyente = datosEmisor?.tipoContribuyente === '1'
    const emisorJuridico = datosEmisor?.tipoEmpresa === '1'
    const receptorGranContribuyente = TipoContribuyenteReceptor === 'true'

    const totales = totalesDeDocumento(productos, {
        aplicaPercepcion: emisorGranContribuyente && emisorJuridico && !receptorGranContribuyente,
        aplicaRetencion: !emisorGranContribuyente && receptorGranContribuyente,
        otrosImpuestosDeLinea: (producto, venta) => processOtrosImpuestosCalculo('05', producto, venta, false),
        resumenTributosDeLinea: (resumen, producto, venta) => procesOtrosImpuestosResumen('05', resumen, producto, venta),
    })

    const normativaV2 = esNormativaV2(datosEmisor)

    const basesGravadasPorItem = totales.lineas.map(({venta, tipoMonto}) =>
        tipoMonto === 'gravado' && venta > 0 ? venta : 0
    )

    const ivaPercibidoPorItem = repartirPorBase(totales.ivaPercibido, basesGravadasPorItem)
    const ivaRetenidoPorItem = repartirPorBase(totales.ivaRetenido, basesGravadasPorItem)

    const ivaPorItem: Record<string, {iva: number, percibido: number, retenido: number}> = {}
    productos.forEach((producto, indice) => {
        ivaPorItem[`${producto.id}`] = {
            iva: ivaSobreBase(basesGravadasPorItem[indice]),
            percibido: ivaPercibidoPorItem[indice],
            retenido: ivaRetenidoPorItem[indice],
        }
    })

    const [tableProductos, setTableProductos] = useState(productos)
    useEffect(() => {
        setTableProductos(productos)
    }, [productos])

    return (
        <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ec5-0b1e6fa6' className='w-layout-layout bill-section wf-layout-layout w-100' >
        <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ed4-0b1e6fa6' className='w-layout-cell w-100' >
        <div className="card">
            <div className="dte-title">
                <label>{view === 'Previsualizacion' ? 'PREVISUALIZACIÓN DE ' : '' }DOCUMENTO TRIBUTARIO ELECTRÓNICO</label>
                <label>NOTA DE CRÉDITO</label>
            </div>
            <div className="separador" />
            <div className='dt-card-grid-2c-1r' style={{alignItems: 'center'}}>
                <div className='dt-card-2c-1r-no-border' style={{textAlign: 'center'}}>
                    <img alt="Logo" src={getLogoEmpresa()} className='logo-itprofis'/>
                </div>
                <div className='dt-card-2c-1r' style={{padding:"3% 0"}}>
                    <table className="dte-table">
                        <tr>
                            <td>Documento Tributario Electrónico Versión:</td>
                            <td>{versionDteEmision(TIPO_DTE.NOTA_CREDITO, datosEmisor) || ''}</td>
                        </tr>
                        <tr>
                            <td>Código de Generación:</td>
                            <td>{datosUUID?.CodigoGeneracion}</td>
                        </tr>
                        <tr>
                            <td>Sucursal:</td>
                            <td>{sucursal}</td>
                        </tr>
                        <tr>
                            <td>Serie:</td>
                            <td>{serie}</td>
                        </tr>
                        <tr>
                            <td>Moneda:</td>
                            <td>USD - Dólar estadounidense</td>
                        </tr>
                    </table>
                </div>
            </div>
            <div className='dt-card-grid-2c-1r'>
                {/* DATOS DEL RECEPTOR */}
                <div className='dt-card-2c-1r' style={{padding:"3% 0"}}>
                <div className='dt-center-content'>
                    <label className="dte-subsection-title">Receptor</label>
                    <table className="dte-table">
                        <tr><td>Nombre:</td><td>{receptor?.nombre}</td></tr>
                        {normativaV2
                            ? <>
                                <tr><td>Tipo de documento:</td><td>{tipoDocumento.find((doc) => doc.codigo === '36')?.valor ?? 'NIT'}</td></tr>
                                <tr><td>Número de documento:</td><td>{receptor?.nit}</td></tr>
                              </>
                            : <tr><td>NIT:</td><td>{receptor?.nit}</td></tr>
                        }
                        <tr><td>NRC:</td><td>{receptor?.nrc}</td></tr>
                        <tr><td>Actividad económica:</td><td>{actividadesEconomicas.find((actividad) => actividad.codigo === receptor?.codActividad)?.valor}</td></tr>
                        <tr><td>Teléfono celular:</td><td>{receptor?.telefono}</td></tr>
                        <tr><td>Correo electrónico:</td><td>{unirChipsReturnFirst(formCliente?.chipsEmail, formCliente?.email)}</td></tr>
                        <tr><td>Dirección:</td><td>{receptor?.direccion?.complemento}</td></tr>
                        <tr><td>Departamento:</td><td>{departamentos.find((departamento) => departamento.codigo === receptor?.direccion?.departamento)?.valor?.toUpperCase() }</td></tr>
                        <tr><td>Municipio:</td><td>{municipios.find((municipio) => municipio.codigo === receptor?.direccion?.municipio)?.valor?.toUpperCase() }</td></tr>
                        <FilaDistritoDTE distrito = {formCliente?.distrito || receptor?.direccion?.distrito}/>
                        <tr><td>Envío de documento por correo electrónico a:</td><td>{unirChipsJoin(formCliente?.chipsEmail, formCliente?.email)}</td></tr>
                    </table>
                </div>
                </div>
                {/* DATOS DEL EMISOR */}
                <div className='dt-card-2c-1r' style={{padding:"3% 0"}}>
                    <div className='dt-center-content'>
                    <label className="dte-subsection-title">Emisor</label>
                    <table className="dte-table">
                        <tr><td>Tipo de persona:</td><td>{datosEmisor?.desTipoEmpresa ?? ''}</td></tr>
                        <tr><td>Tipo de contribuyente:</td><td>{datosEmisor?.desContribuyente ?? ''}</td></tr>
                        <tr><td>Nombre del cliente:</td><td>{datosEmisor?.nombre}</td></tr>
                        <tr><td>Dirección:</td><td>{datosEmisor?.complemento}</td></tr>
                        <tr><td>Departamento:</td><td>{datosEmisor?.departamentonombre}</td></tr>
                        <tr><td>Municipio:</td><td>{datosEmisor?.municipionombre}</td></tr>
                        <FilaDistritoEmisor />
                        <tr><td>Giro:</td><td>{datosEmisor?.descactividad}</td></tr>
                        <tr><td>NIT:</td><td>{datosEmisor?.nit}</td></tr>
                        <tr><td>NRC:</td><td>{datosEmisor?.nrc}</td></tr>
                        <tr><td>Teléfono celular:</td><td>{datosEmisor?.telefono}</td></tr>
                        <tr><td>Correo electrónico:</td><td>{datosEmisor?.correo}</td></tr>
                        <FilaFusionDTE/>
                    </table>
                </div>
                </div>
            </div>
            <div className="dte-section">
              <div className="dte-subsection">
                  <label className="dte-subsection-title">Documento de referencia</label>
                  <div className="table-facturacion-resp">
                  <table className="table-main-responsive responsive-table-main td-left table-pointer" style={{marginTop: '8px'}}>
                      <thead>
                          <tr>
                              <td>Tipo de documento</td>
                              <td>Número de control</td>
                              <td>Código de documento</td>
                              <td>Fecha de emisión</td>
                          </tr>
                      </thead>
                      <tbody>
                        <tr>
                            <td data-label="Tipo de documento">{tipoDocumentosEmision.find((tipoDoc) => tipoDoc.iddocumento === parseInt(identificacion.tipoDte))?.nombre}</td>
                            <td data-label="Número de control">{identificacion.numeroControl}</td>
                            <td data-label="Código de documento">{identificacion.codigoGeneracion}</td>
                            <td data-label="Fecha de emisión">{getFechaCA(identificacion.fecEmi)}</td>
                        </tr>
                      </tbody>
                  </table>
                 </div>
              </div>
            </div>
            <div className="tab-plane" style={{marginTop: "25px"}}>
            <div className="table-facturacion-resp">
            <table className="table-main-responsive responsive-table-main td-left table-pointer">
                        <thead>
                            <tr>
                                <td>Cantidad</td>
                                <td>Unidad de medida</td>
                                <td>Tipo</td>
                                <td>Descripción</td>
                                <td>Precio unitario</td>
                                <td>Otros impuestos</td>
                                <td>Descuento</td>
                                <td>Ventas gravadas</td>
                                <td>Ventas exentas</td>
                                <td>Ventas no sujetas</td>
                                {normativaV2 && <td>IVA 13%</td>}
                                {normativaV2 && <td>IVA percibido</td>}
                                {normativaV2 && <td>IVA retenido</td>}
                            </tr>
                        </thead>
                        <tbody>
                        {tableProductos.map((producto, index) => {
                                const precioUnitario = precioUnitarioNeto(producto.precio, producto.conIva)
                                const {descuento, venta} = montosDeProducto(producto)
                                const detalleTributos = processDetalleImpuestosHTML(productosCatalogo, '05', producto, venta);

                                return(
                                <tr key={index}>
                                    <td data-label="Cantidad">{producto.cantidad}</td>
                                    <td data-label="Unidad de medida">{unidadesMedida.find((unidad) => unidad.codigo === producto.unidadMedida)?.valor}</td>
                                    <td data-label="Tipo">{`${producto.servicio ? 'Servicio' : 'Producto'}${producto.exento ? ' exento' : producto.noSujeto ? ' no sujeto' : ''}`}</td>
                                    <td data-label="Descripción" style={{wordBreak:"break-all"}}>{<div dangerouslySetInnerHTML={{ __html: producto.descripcion }} />}</td>
                                    <td data-label="Precio unitario">
                                        {precioUnitario.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}
                                    </td>
                                    <td data-label="Otros impuestos"><div dangerouslySetInnerHTML={{ __html: detalleTributos }} /></td>
                                    <td data-label="Descuento">
                                        {descuento.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}
                                    </td>
                                    <td data-label="Ventas gravadas">{(!producto.exento && !producto.noSujeto && !producto.noGravado) ? venta.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'}): '$0.00'}</td>
                                    <td data-label="Ventas exentas">{producto.exento ? venta.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'}): '$0.00'}</td>
                                    <td data-label="Ventas no sujetas">{producto.noSujeto ? venta.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'}): '$0.00'}</td>
                                    {normativaV2 && <td data-label="IVA 13%">{formatearDolares(ivaPorItem[`${producto.id}`]?.iva ?? 0)}</td>}
                                    {normativaV2 && <td data-label="IVA percibido">{formatearDolares(ivaPorItem[`${producto.id}`]?.percibido ?? 0)}</td>}
                                    {normativaV2 && <td data-label="IVA retenido">{formatearDolares(ivaPorItem[`${producto.id}`]?.retenido ?? 0)}</td>}
                                </tr>
                            )})}
                        </tbody>
            </table>
            </div>
                    <Pagination data = {productos} state = {(items: Array<any>) => setTableProductos(items)} items = {10}/>
                    <div className="cf-calculos-producto">
                        <table>
                            <tbody>
                                <tr className="cf-subtotal">
                                    <td>Suma de operaciones</td>
                                    <td>{totales.sumaOperaciones.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                </tr>
                                <tr className="cf-subtotal">
                                    <td>Impuesto al Valor Agregado 13%</td>
                                    <td>{totales.iva.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                </tr>
                                <tr className="cf-subtotal">
                                    <td>Otros impuestos</td>
                                    <td>{totales.otrosImpuestos.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                </tr>
                                <tr className="cf-subtotal">
                                    <td>Subtotal</td>
                                    <td>{totales.subtotal.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                </tr>
                                <tr className="cf-subtotal">
                                    <td>IVA percibido 1%</td>
                                    <td>{totales.ivaPercibido.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                </tr>
                                <tr className="cf-subtotal">
                                    <td>IVA retenido 1%</td>
                                    <td>{totales.ivaRetenido.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                </tr>
                                {!normativaV2 &&
                                    <tr className="cf-descuento">
                                        <td>Retencion renta 10%</td>
                                        <td>{totales.retencionRenta.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                    </tr>
                                }
                                {normativaV2 &&
                                    <tr className="cf-subtotal">
                                        <td>Código de retención de IVA</td>
                                        <td>{formCliente?.codigoRetencionMH || 'Sin código'}</td>
                                    </tr>
                                }
                                <tr className="cf-total">
                                    <td>Total</td>
                                    <td>{totales.total.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                </tr>
                                <tr className="cf-total" style={{opacity: 0.5}}>
                                    <td>Total original</td>
                                    <td>{totalOriginal?.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
            </div>
            
            <div className='dt-card w-100 text-center' style={{padding: 0}}>
            {response_QRcode ? <div className='dt-card-grid-3c'>
              {response_QRcode && <div>
                <img src={response_QRcode} alt='qr' className='dt-img-qr'/>
              </div>}
              <div className='dt-card-2c-responsive'>
                <div className='detail'>
                  <label>Responsable por parte del Emisor:</label>
                  <label>{datos?.name}</label>
                </div>
                <div className='detail'>
                  <label>Responsable por parte del Receptor:</label>
                <label>{datosReceptor.nombre ? datosReceptor.nombre : receptor?.nombre}</label>
                </div>
              </div>
              <div className='dt-card-2c-responsive'>
                <div className='detail'>
                  <label>{`${datos?.tipo_documento}:`}</label>
                  <label>{datos?.documento}</label>
                </div>
                <div className='detail'>
                  <label>{`${datosReceptor.nombreTipoDocumento ? `${datosReceptor.nombreTipoDocumento}`: tipoDocumento.find((doc) => doc.codigo === formCliente.tipoDocumento)?.valor}:`}</label>
                  <label>{datosReceptor.nombreTipoDocumento ? datosReceptor.numId : receptor?.nit}</label>
                </div>
              </div>
            </div> :
            <div className={'dt-card-grid-2c'}>
                <div className='detail'>
                  <label>Responsable por parte del Emisor:</label>
                  <label>{datos?.name}</label>
                </div>
                <div className='detail'>
                  <label>{`${datos?.tipo_documento}:`}</label>
                  <label>{datos?.documento}</label>
                </div>
                <div className='detail'>
                  <label>Responsable por parte del Receptor:</label>
                <label>{datosReceptor.nombre ? datosReceptor.nombre : receptor?.nombre}</label>
                </div>
                <div className='detail'>
                  <label>{`${datosReceptor.nombreTipoDocumento ? `${datosReceptor.nombreTipoDocumento}`: tipoDocumento.find((doc) => doc.codigo === formCliente.tipoDocumento)?.valor}:`}</label>
                  <label>{datosReceptor.nombreTipoDocumento ? datosReceptor.numId : receptor?.nit}</label>
                </div>
            </div> }
            </div>
        </div>
        </div>
        </div>
    )
}